export default __webpack_public_path__ + "locales/ja-JP/Article.json?hash=6e161c2eb0ebcd4d5dee277b2b26c077";